/**
 * Simple Product Customizer JS
 * Handles: Variant selection, frame preview, gift options with overlays, add to cart, sticky cart
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  
  const CONFIG = {
    giftProducts: {
      ribbon: '55259137802617',
      giftwrap: '56160831930745',
      bundle: '56160845988217'
    },
    frameStyles: {
      black: {
        borderWidth: '22px',
        borderStyle: 'solid',
        borderColor: 'rgba(33, 33, 33, 0.75)',
        borderImage: 'url(https://cdn.shopify.com/s/files/1/0710/5278/7987/t/104/assets/frame-black-v3.webp) 100 / 1 / 0 stretch'
      },
      white: {
        borderWidth: '22px',
        borderStyle: 'solid',
        borderColor: 'rgb(255, 255, 255)',
        borderImage: 'url(https://cdn.shopify.com/s/files/1/0710/5278/7987/t/104/assets/frame-white-v3.webp) 115 / 1 / 0 stretch'
      },
      natural: {
        borderWidth: '22px',
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderImage: 'url(https://cdn.shopify.com/s/files/1/0710/5278/7987/t/104/assets/frame-natural-v3.webp) 110 / 1 / 0 stretch'
      },
      darkBrown: {
        borderWidth: '22px',
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderImage: 'url(https://cdn.shopify.com/s/files/1/0710/5278/7987/t/104/assets/frame-dark-brown-v3.webp) 110 / 1 / 0 stretch'
      },
      none: {
        borderWidth: '0',
        borderStyle: 'none',
        borderColor: 'transparent',
        borderImage: 'none'
      }
    },
    overlayImages: {
      ribbon: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-GIFT-WRAP.png?v=1748258725',
      ribbonLandscape: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-GIFT-WRAP-landscape-4x3.webp?v=1788638451',
      giftWrap: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/Skylit-studio-wrapping-paper-5.webp?v=1762717492'
    }
  };

  // ============================================
  // STATE
  // ============================================
  
  const state = {
    selectedGift: 'none',
    selectedGiftId: null,
    ribbonSelected: false,
    giftWrapSelected: false,
    bundleSelected: false,
    giftPaper: 'dots'
  };

  // Expose to window for compatibility
  window.ribbonSelected = false;
  window.giftWrapSelected = false;
  window.bundleSelected = false;

  // ============================================
  // INITIALIZATION
  // ============================================
  
  function init() {
    console.log('Simple Product Customizer initializing...');
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onDOMReady);
    } else {
      onDOMReady();
    }
  }

  // Gift wrap and the bundle are priced by the print size being wrapped, but
  // the pills render from the gift product's FIRST variant (smallest tier).
  // Re-stamp them whenever a picker click could have changed the size.
  function spSelectedSize() {
    var el = document.querySelector('.state__picker.state_2:not([style*="display: none"]) .active__picker .info__picker p') ||
             document.querySelector('.state__picker.state_2 .active__picker .info__picker p');
    return el ? el.textContent.trim() : '';
  }
  function spRefreshGiftLabels() {
    try {
      if (window.SkylitGifts) window.SkylitGifts.refreshLabels(spSelectedSize());
    } catch (e) {}
  }

  function onDOMReady() {
    setTimeout(() => {
      initVariantSelector();
      initPickerClicks();
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.elem__picker')) {
          setTimeout(spRefreshGiftLabels, 0);
        }
      });
      spRefreshGiftLabels();
      initGiftOptions();
      initFormSubmit();
      initStickyCart();
      initStickySelectors();

      // Set initial selections: Black Frame + A4
      setInitialSelections();
      
      console.log('Simple Product Customizer ready');
    }, 100);
  }

  function setInitialSelections() {
    // Determine the target variant. Honor a ?variant= deep link (Google Shopping
    // links, automated-discount test links, shared variant URLs) so the page
    // opens on the requested variant. Only fall back to the Black Frame + A4
    // default when no specific variant is requested. Forcing Black/A4 here used
    // to clobber the URL variant, which broke the Google automated discount: it
    // moved the shopper off the entitled variant so the discount was withheld.
    let target = null;
    try {
      const requestedId = new URLSearchParams(window.location.search).get('variant');
      if (requestedId && window.productData && window.productData.variants) {
        target = window.productData.variants.find(v => String(v.id) === String(requestedId)) || null;
      }
    } catch (e) {}

    const finishOptions = document.querySelectorAll('.elem__picker.elem__state.state_1');
    if (!finishOptions.length) return;

    // Select the finish (option1) picker.
    let finishOption = null;
    if (target && target.option1) {
      const wanted = target.option1.trim().toLowerCase();
      finishOptions.forEach(opt => {
        const text = (opt.querySelector('.info__picker p')?.textContent || '').trim().toLowerCase();
        if (text === wanted) finishOption = opt;
      });
    }
    // Fallback: Classic Black Frame (or any "black"), else first option.
    if (!finishOption) {
      finishOptions.forEach(opt => {
        const text = opt.querySelector('.info__picker p')?.textContent.toLowerCase() || '';
        if (text.includes('black')) finishOption = opt;
      });
    }
    if (!finishOption) finishOption = finishOptions[0];

    finishOption.click();

    // After the finish click reveals the matching size / frame-colour sections,
    // select the target size (option2) and frame colour (option3) when the URL
    // specified them, otherwise default to A4.
    setTimeout(() => {
      const stateAttr = finishOption.getAttribute('data-state');

      // option2 (size)
      const sizeSection = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"]`);
      if (sizeSection) {
        const sizeOptions = sizeSection.querySelectorAll('.elem__picker');
        let sizeOption = null;
        if (target && target.option2) {
          const wantedSize = target.option2.trim().toLowerCase();
          sizeOptions.forEach(opt => {
            const text = (opt.querySelector('.info__picker p')?.textContent || '').trim().toLowerCase();
            if (text === wantedSize) sizeOption = opt;
          });
        }
        // Fallback to A4, then first.
        if (!sizeOption) {
          sizeOptions.forEach(opt => {
            const text = opt.querySelector('.info__picker p')?.textContent.toLowerCase() || '';
            if (text.includes('a4')) sizeOption = opt;
          });
        }
        if (!sizeOption && sizeOptions.length) sizeOption = sizeOptions[0];
        if (sizeOption) {
          sizeOptions.forEach(el => el.classList.remove('active__picker'));
          sizeOption.classList.add('active__picker');
        }
      }

      // option3 (frame colour) - only for products where it is a separate,
      // visible option and the URL variant specifies it.
      if (target && target.option3) {
        const colourSection = document.querySelector(`.state__picker.state_3[data-state="${stateAttr}"]`);
        if (colourSection && colourSection.style.display !== 'none') {
          const colourOptions = colourSection.querySelectorAll('.elem__picker');
          let colourOption = null;
          const wantedColour = target.option3.trim().toLowerCase();
          colourOptions.forEach(opt => {
            const text = (opt.querySelector('.info__picker p')?.textContent || '').trim().toLowerCase();
            if (text === wantedColour) colourOption = opt;
          });
          if (colourOption) {
            colourOptions.forEach(el => el.classList.remove('active__picker'));
            colourOption.classList.add('active__picker');
          }
        }
      }

      // Update variant + sticky cart
      updateVariantFromPickers();
      updateStickyCart();
    }, 50);
  }

  // ============================================
  // VARIANT SELECTOR (Shopify Integration)
  // ============================================
  
  function initVariantSelector() {
    if (typeof Shopify === 'undefined' || !window.productData) {
      console.warn('Shopify or productData not available');
      return;
    }

    try {
      new Shopify.OptionSelectors('product-select', {
        product: window.productData,
        onVariantSelected: onVariantChange,
        enableHistoryState: true
      });
    } catch (e) {
      console.warn('OptionSelectors init error:', e);
    }
  }

  function onVariantChange(variant, selector) {
    if (!variant) return;
    
    console.log('Variant changed:', variant);
    
    // Update price display
    const priceEl = document.querySelector('.add__cart--price > p');
    if (priceEl && typeof Shopify !== 'undefined') {
      priceEl.innerHTML = Shopify.formatMoney(variant.price, window.currencyFormat);
    }
    
    // Update hidden variant ID
    const varIdInput = document.getElementById('var_id');
    if (varIdInput) {
      varIdInput.value = variant.id;
    }
    
    // Update product description from metafields
    const descEl = document.querySelector('.pro_desc');
    if (descEl && window.metafields && window.metafields[variant.id]) {
      descEl.innerHTML = window.metafields[variant.id];
    }
    
    // Update sticky cart
    updateStickyCart();
  }

  // ============================================
  // FRAME UPDATE LOGIC
  // ============================================
  
  function updateFrameFromSelection(selectedText) {
    const frameEl = document.querySelector('.custom-frame');
    if (!frameEl) return;
    
    const text = selectedText.toLowerCase();
    
    console.log('Updating frame for:', text);
    
    if (text.includes('black')) {
      applyFrameStyle(frameEl, CONFIG.frameStyles.black);
    } else if (text.includes('white') || text.includes('elegant')) {
      applyFrameStyle(frameEl, CONFIG.frameStyles.white);
    } else if (text.includes('dark brown')) {
      applyFrameStyle(frameEl, CONFIG.frameStyles.darkBrown);
    } else if (text.includes('natural') || text.includes('brown') || text.includes('wood')) {
      applyFrameStyle(frameEl, CONFIG.frameStyles.natural);
    } else if (text.includes('unframed') || text.includes('print') || text.includes('canvas') || text.includes('digital')) {
      applyFrameStyle(frameEl, CONFIG.frameStyles.none);
    }
    
    // Re-render overlays after frame change (with delay to get new dimensions)
    setTimeout(renderOverlays, 100);
  }

  function applyFrameStyle(element, styles) {
    // Reset first
    element.style.border = '';
    element.style.borderWidth = '';
    element.style.borderStyle = '';
    element.style.borderColor = '';
    element.style.borderImage = '';
    
    // Apply new styles
    Object.keys(styles).forEach(prop => {
      element.style[prop] = styles[prop];
    });
  }

  // ============================================
  // GIFT WRAP OVERLAY RENDERING - FIXED
  // ============================================
  
  function renderOverlays() {
    const frame = document.querySelector('.custom-frame');
    const printContainer = document.querySelector('#print');
    
    if (!frame || !printContainer) {
      console.log('Frame or print container not found');
      removeOverlays();
      return;
    }
    
    // Remove existing overlays first
    removeOverlays();
    
    // If no gift selected, exit
    if (!window.giftWrapSelected && !window.ribbonSelected && !window.bundleSelected) {
      console.log('No gift options selected');
      return;
    }
    
    // Get frame dimensions including border
    const frameWidth = frame.offsetWidth;
    const frameHeight = frame.offsetHeight;
    
    // Get frame position relative to print container
    const printRect = printContainer.getBoundingClientRect();
    const frameRect = frame.getBoundingClientRect();
    
    const offsetLeft = frameRect.left - printRect.left;
    const offsetTop = frameRect.top - printRect.top;
    
    console.log('Frame dimensions:', frameWidth, 'x', frameHeight, 'Offset:', offsetLeft, offsetTop);
    
    // Ensure print container has relative positioning
    printContainer.style.position = 'relative';
    
    // Handle gift wrap overlay (lower z-index, appears below ribbon)
    if (window.giftWrapSelected || window.bundleSelected) {
      console.log('Adding gift wrap overlay');
      const giftWrapOverlay = document.createElement('img');
      giftWrapOverlay.className = 'gift-wrap-overlay';
      giftWrapOverlay.src = (window.SkylitGifts && window.SkylitGifts.designMeta(state.giftPaper).texture) || CONFIG.overlayImages.giftWrap;
      giftWrapOverlay.alt = 'Gift Wrap';
      
      Object.assign(giftWrapOverlay.style, {
        position: 'absolute',
        width: frameWidth + 'px',
        height: frameHeight + 'px',
        left: offsetLeft + 'px',
        top: offsetTop + 'px',
        pointerEvents: 'none',
        zIndex: '100',
        opacity: '0.85',
        objectFit: 'cover'
      });
      
      printContainer.appendChild(giftWrapOverlay);
    }
    
    // Handle ribbon overlay (higher z-index, appears above gift wrap)
    if (window.ribbonSelected || window.bundleSelected) {
      console.log('Adding ribbon overlay');
      const ribbonOverlay = document.createElement('img');
      ribbonOverlay.className = 'ribbon-overlay';
      ribbonOverlay.src = document.querySelector('.app__wrapper.sp--landscape') ? CONFIG.overlayImages.ribbonLandscape : CONFIG.overlayImages.ribbon;
      ribbonOverlay.alt = 'Ribbon';
      
      // Use object-fit: fill to ensure ribbon stretches to edges
      Object.assign(ribbonOverlay.style, {
        position: 'absolute',
        width: frameWidth + 'px',
        height: frameHeight + 'px',
        left: offsetLeft + 'px',
        top: offsetTop + 'px',
        pointerEvents: 'none',
        zIndex: '101',
        objectFit: 'fill'
      });
      
      printContainer.appendChild(ribbonOverlay);
    }
    
    console.log('Overlays rendered - Ribbon:', window.ribbonSelected, 'Gift Wrap:', window.giftWrapSelected, 'Bundle:', window.bundleSelected);
  }
  
  function removeOverlays() {
    document.querySelectorAll('.gift-wrap-overlay, .ribbon-overlay').forEach(el => el.remove());
  }

  // ============================================
  // PICKER CLICK HANDLERS
  // ============================================
  
  function initPickerClicks() {
    document.addEventListener('click', function(e) {
      const picker = e.target.closest('.elem__picker');
      if (!picker) return;
      
      // Skip if this is a gift option (handled separately)
      if (picker.closest('#gift-options-section')) return;
      
      const grid = picker.closest('.grid__picker');
      if (!grid) return;
      
      // Check if sold out
      if (picker.classList.contains('sold-out') || picker.dataset.available === 'false') {
        console.log('Variant sold out');
        return;
      }
      
      // Remove active from siblings
      grid.querySelectorAll('.elem__picker').forEach(el => {
        el.classList.remove('active__picker');
      });
      
      // Add active to clicked
      picker.classList.add('active__picker');
      
      // Get the selected text for frame updates
      const infoText = picker.querySelector('.info__picker p');
      const selectedText = infoText ? infoText.textContent.trim() : '';
      
      // Handle state-based visibility (product type changes)
      if (picker.classList.contains('state_1')) {
        handleProductTypeChange(picker);
        // Update frame based on product type selection
        updateFrameFromSelection(selectedText);
      }
      
      // Handle frame color selection (if separate state_3)
      if (picker.closest('.state_3')) {
        updateFrameFromSelection(selectedText);
      }
      
      // Update variant selector
      updateVariantFromPickers();
      
      // Update sticky cart
      updateStickyCart();
    });
  }

  function handleProductTypeChange(picker) {
    const stateAttr = picker.getAttribute('data-state');
    if (!stateAttr) return;
    
    // Hide all state pickers
    document.querySelectorAll('.state__picker').forEach(el => {
      el.style.display = 'none';
    });
    
    // Show matching state pickers (size, frame)
    document.querySelectorAll(`.state__picker[data-state="${stateAttr}"]`).forEach(el => {
      el.style.display = '';
    });
    
    // For products where frame type is in option1 (combined), hide state_3
    const pickerText = picker.querySelector('.info__picker p');
    const text = pickerText ? pickerText.textContent.toLowerCase() : '';
    
    // If the option already specifies frame color, hide state_3
    if (text.includes('black') || text.includes('white') || text.includes('natural') || 
        text.includes('unframed') || text.includes('canvas') || text.includes('digital')) {
      document.querySelectorAll('.state__picker.state_3').forEach(el => {
        el.style.display = 'none';
      });
    }
    
    // Handle gift options visibility based on product type
    const isUnframed = text.includes('unframed') || text.includes('print') || text.includes('digital');
    const giftSection = document.querySelector('#gift-options-section');
    
    if (giftSection) {
      const giftWrapOption = giftSection.querySelector('[data-gift="giftwrap"]');
      const bundleOption = giftSection.querySelector('[data-gift="bundle"]');
      
      if (isUnframed) {
        // Hide wrap and bundle for unframed
        if (giftWrapOption) giftWrapOption.style.display = 'none';
        if (bundleOption) bundleOption.style.display = 'none';
        
        // If wrap or bundle was selected, reset to No Gift
        if (state.giftWrapSelected || state.bundleSelected) {
          const noGiftOption = giftSection.querySelector('[data-gift="none"]');
          if (noGiftOption) {
            noGiftOption.click();
          }
        }
      } else {
        // Show all options for framed/canvas
        if (giftWrapOption) giftWrapOption.style.display = '';
        if (bundleOption) bundleOption.style.display = '';
      }
    }
    
    // Auto-select first option in each visible state picker
    document.querySelectorAll(`.state__picker[data-state="${stateAttr}"]`).forEach(statePicker => {
      if (statePicker.style.display !== 'none') {
        const firstOption = statePicker.querySelector('.elem__picker');
        const hasActive = statePicker.querySelector('.elem__picker.active__picker');
        if (firstOption && !hasActive) {
          firstOption.classList.add('active__picker');
        }
      }
    });
  }

  function updateVariantFromPickers() {
    // Get selected option1 (product type/finish)
    const option1El = document.querySelector('.state_1.active__picker .info__picker p');
    const option1 = option1El ? option1El.textContent.trim() : null;
    
    if (!option1) return;
    
    // Get active state
    const activeState = document.querySelector('.state_1.active__picker');
    const stateAttr = activeState ? activeState.getAttribute('data-state') : null;
    
    // Get selected option2 (size)
    const option2El = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"] .active__picker .info__picker p`);
    const option2 = option2El ? option2El.textContent.trim() : null;
    
    // Get selected option3 (frame color) if applicable and visible
    const state3El = document.querySelector(`.state__picker.state_3[data-state="${stateAttr}"]`);
    let option3 = null;
    if (state3El && state3El.style.display !== 'none') {
      const option3El = state3El.querySelector('.active__picker .info__picker p');
      option3 = option3El ? option3El.textContent.trim() : null;
    }
    
    // Trigger option selector changes
    selectOption(0, option1);
    if (option2) selectOption(1, option2);
    if (option3) selectOption(2, option3);
  }

  function selectOption(index, value) {
    const selectors = document.querySelectorAll('.single-option-selector');
    const selector = selectors[index];
    if (selector) {
      const option = Array.from(selector.options).find(opt => opt.value === value);
      if (option) {
        selector.value = value;
        selector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // ============================================
  // GIFT OPTIONS
  // ============================================
  
  function initGiftOptions() {
    // Set defaults
    state.selectedGift = 'none';
    state.selectedGiftId = null;
    state.ribbonSelected = false;
    state.giftWrapSelected = false;
    state.bundleSelected = false;
    
    window.ribbonSelected = false;
    window.giftWrapSelected = false;
    window.bundleSelected = false;
    
    const giftSection = document.querySelector('#gift-options-section');
    if (!giftSection) {
      console.warn('Gift options section not found');
      return;
    }
    
    const giftPickers = giftSection.querySelectorAll('.elem__picker');
    console.log('Found gift pickers:', giftPickers.length);
    
    giftPickers.forEach(picker => {
      picker.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Remove active from siblings
        giftSection.querySelectorAll('.elem__picker').forEach(el => {
          el.classList.remove('active__picker');
        });
        
        // Add active to clicked
        this.classList.add('active__picker');
        
        const giftType = this.getAttribute('data-gift') || 'none';
        const giftId = this.getAttribute('data-gift-id') || null;
        
        state.selectedGift = giftType;
        state.selectedGiftId = giftId;
        
        // Set flags based on selection
        state.ribbonSelected = giftType === 'ribbon' || giftType === 'bundle';
        state.giftWrapSelected = giftType === 'giftwrap' || giftType === 'bundle';
        state.bundleSelected = giftType === 'bundle';
        var pw = document.getElementById('sp-gift-paper-wrap');
        if (pw) pw.setAttribute('data-gift-paper-visible', state.giftWrapSelected ? 'true' : 'false');

        // Expose to window
        window.ribbonSelected = state.ribbonSelected;
        window.giftWrapSelected = state.giftWrapSelected;
        window.bundleSelected = state.bundleSelected;

        console.log('Gift selected:', giftType, 'Ribbon:', window.ribbonSelected, 'GiftWrap:', window.giftWrapSelected);

        // Render overlays
        renderOverlays();
      });
    });

    if (window.SkylitGifts) {
      window.SkylitGifts.bindPaperPicker(document.getElementById('sp-gift-paper'), function (id) {
        state.giftPaper = id;
        if (typeof renderOverlays === 'function') renderOverlays();
      });
    }
  }

  // ============================================
  // STICKY CART FUNCTIONALITY
  // ============================================
  
  function initStickyCart() {
    const stickyCart = document.getElementById('sticky-cart');
    const appWrapper = document.querySelector('.app__wrapper');
    
    if (!stickyCart || !appWrapper) return;
    
    // Scroll listener to show/hide sticky cart
    let ticking = false;
    
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkStickyVisibility();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check
    checkStickyVisibility();
    
    // Sticky cart button click
    const stickyBtn = document.getElementById('sticky-add-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        addToCart();
      });
    }
  }

  function checkStickyVisibility() {
    const stickyCart = document.getElementById('sticky-cart');
    const mainAddToCart = document.querySelector('.submit__form-wrapper');

    if (!stickyCart || !mainAddToCart) return;

    const mainRect = mainAddToCart.getBoundingClientRect();

    // Check if the main footer at bottom of page is about to overlap
    // Try to find the last/bottom-most footer element only
    const footers = document.querySelectorAll('footer');
    let footerVisible = false;

    if (footers.length > 0) {
      // Get the last footer (usually the main page footer)
      const footer = footers[footers.length - 1];
      const footerRect = footer.getBoundingClientRect();
      const stickyHeight = stickyCart.offsetHeight || 80;

      // Only hide when footer is actually close to overlapping (20px buffer)
      footerVisible = footerRect.top < window.innerHeight - (stickyHeight + 20);
    }

    // Show sticky cart when main ATC is above viewport (scrolled past)
    // BUT hide it when footer is about to overlap
    if (mainRect.bottom < 0 && !footerVisible) {
      stickyCart.classList.add('visible');
    } else {
      stickyCart.classList.remove('visible');
    }
  }

  function updateStickyCart() {
    // Update variant text
    const stickyVariantText = document.getElementById('sticky-variant-text');
    if (stickyVariantText) {
      const option1El = document.querySelector('.elem__state.state_1.active__picker .info__picker p');
      const option1 = option1El ? option1El.textContent.trim() : '';

      const activeState = document.querySelector('.elem__state.state_1.active__picker');
      const stateAttr = activeState ? activeState.getAttribute('data-state') : null;

      const option2El = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"] .active__picker .info__picker p`);
      const option2 = option2El ? option2El.textContent.trim() : '';

      stickyVariantText.textContent = option1 + (option2 ? ' - ' + option2 : '');
    }

    // Update price (copy from main price)
    const stickyPrice = document.getElementById('sticky-price');
    const mainPrice = document.querySelector('.add__cart--price > p');
    if (stickyPrice && mainPrice) {
      stickyPrice.textContent = mainPrice.textContent;
    }

    // Update sticky cart selectors
    updateStickySelectors();
  }

  function initStickySelectors() {
    const stickySizeSelect = document.getElementById('sticky-size-select');
    const stickyFrameSelect = document.getElementById('sticky-frame-select');
    const stickyFrameSelector = document.getElementById('sticky-frame-selector');

    if (!stickySizeSelect) return;

    // Populate both frame and size options
    function populateStickySelectors() {
      // Populate Frame selector from state_1 (Framing Options)
      if (stickyFrameSelect && stickyFrameSelector) {
        const frameOptions = document.querySelectorAll('.elem__state.state_1');

        if (frameOptions.length > 0) {
          stickyFrameSelector.style.display = 'flex';
          stickyFrameSelect.innerHTML = '';

          frameOptions.forEach(option => {
            const frameText = option.querySelector('.info__picker p');
            if (frameText) {
              const opt = document.createElement('option');
              opt.value = option.getAttribute('data-state');
              opt.textContent = frameText.textContent.trim();
              if (option.classList.contains('active__picker')) {
                opt.selected = true;
              }
              stickyFrameSelect.appendChild(opt);
            }
          });
        } else {
          stickyFrameSelector.style.display = 'none';
        }
      }

      // Populate Size selector from state_2 based on active frame
      const activeFrame = document.querySelector('.elem__state.state_1.active__picker');
      if (!activeFrame) return;

      const stateAttr = activeFrame.getAttribute('data-state');
      const sizeContainer = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"]`);

      if (sizeContainer) {
        stickySizeSelect.innerHTML = '';
        const sizeOptions = sizeContainer.querySelectorAll('.elem__dropdown');

        sizeOptions.forEach(option => {
          const sizeText = option.querySelector('.info__picker p');
          const isAvailable = option.getAttribute('data-available') === 'true';

          if (sizeText && isAvailable) {
            const opt = document.createElement('option');
            opt.value = option.getAttribute('data-dropdown');
            opt.textContent = sizeText.textContent.trim();
            if (option.classList.contains('active__picker')) {
              opt.selected = true;
            }
            stickySizeSelect.appendChild(opt);
          }
        });
      }
    }

    // Size selector change - click the corresponding size option
    stickySizeSelect.addEventListener('change', function() {
      const selectedValue = this.value;
      const activeFrame = document.querySelector('.elem__state.state_1.active__picker');
      if (!activeFrame) return;

      const stateAttr = activeFrame.getAttribute('data-state');
      const sizeOption = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"] .elem__dropdown[data-dropdown="${selectedValue}"]`);

      if (sizeOption) {
        sizeOption.click();
      }
    });

    // Frame selector change - click the corresponding frame option in state_1
    if (stickyFrameSelect) {
      stickyFrameSelect.addEventListener('change', function() {
        const selectedValue = this.value;
        const frameOption = document.querySelector(`.elem__state.state_1[data-state="${selectedValue}"]`);

        if (frameOption) {
          frameOption.click();
          // Re-populate size options after frame change
          setTimeout(populateStickySelectors, 150);
        }
      });
    }

    // Listen for frame option clicks to keep selectors in sync
    document.querySelectorAll('.elem__state.state_1').forEach(frameOption => {
      frameOption.addEventListener('click', function() {
        setTimeout(populateStickySelectors, 150);
      });
    });

    // Listen for size option clicks to keep selectors in sync
    document.querySelectorAll('.state__picker.state_2 .elem__dropdown').forEach(sizeOption => {
      sizeOption.addEventListener('click', function() {
        setTimeout(populateStickySelectors, 150);
      });
    });

    // Initial population with delay to allow setInitialSelections to run first
    setTimeout(populateStickySelectors, 300);
  }

  function updateStickySelectors() {
    const stickySizeSelect = document.getElementById('sticky-size-select');
    const stickyFrameSelect = document.getElementById('sticky-frame-select');

    if (!stickySizeSelect) return;

    // Update frame select to match active frame (state_1)
    const activeFrame = document.querySelector('.elem__state.state_1.active__picker');
    if (!activeFrame) return;

    if (stickyFrameSelect) {
      const frameValue = activeFrame.getAttribute('data-state');
      if (stickyFrameSelect.querySelector(`option[value="${frameValue}"]`)) {
        stickyFrameSelect.value = frameValue;
      }
    }

    // Update size select to match active size (state_2)
    const stateAttr = activeFrame.getAttribute('data-state');
    const activeSize = document.querySelector(`.state__picker.state_2[data-state="${stateAttr}"] .active__picker`);

    if (activeSize) {
      const sizeValue = activeSize.getAttribute('data-dropdown');
      if (stickySizeSelect.querySelector(`option[value="${sizeValue}"]`)) {
        stickySizeSelect.value = sizeValue;
      }
    }
  }

  // ============================================
  // FORM SUBMISSION / ADD TO CART
  // ============================================
  
  function initFormSubmit() {
    const form = document.getElementById('product-form');
    if (!form) return;
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      addToCart();
    });
  }

  async function addToCart() {
    const loader = document.querySelector('.myloader');
    if (loader) loader.style.display = 'block';
    
    const variantId = document.getElementById('var_id').value;
    if (!variantId) {
      alert('Please select a product variant');
      if (loader) loader.style.display = 'none';
      return;
    }
    
    try {
      // Wrap/bundle are size-tiered by the print size being wrapped; the
      // CONFIG ids (smallest tier) stay as the fallback.
      function spGiftVariantId(kind, fallback) {
        try {
          var el = document.querySelector('.state__picker.state_2:not([style*="display: none"]) .active__picker .info__picker p') ||
                   document.querySelector('.state__picker.state_2 .active__picker .info__picker p');
          var size = el ? el.textContent.trim() : '';
          var tiered = window.SkylitGifts && window.SkylitGifts.variantFor(kind, size, state.giftPaper);
          if (tiered) return String(tiered);
        } catch (e) {}
        return fallback;
      }

      var paperKey = window.SkylitGifts ? window.SkylitGifts.designKey(state.giftPaper) : 'regular';
      var paperLabel = window.SkylitGifts ? window.SkylitGifts.labelFor(paperKey) : 'Regular';

      // Build cart items
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      // Add gift products based on selection
      if (state.bundleSelected) {
        formData.items.push({
          id: spGiftVariantId('bundle', CONFIG.giftProducts.bundle),
          quantity: 1,
          properties: { 'Ribbon Colour': 'Red', 'Gift Wrap Theme': paperLabel, _gift_wrap_theme: paperKey }
        });
      } else if (state.ribbonSelected) {
        formData.items.push({
          id: CONFIG.giftProducts.ribbon,
          quantity: 1,
          properties: { 'Ribbon Colour': 'Red' }
        });
      } else if (state.giftWrapSelected) {
        formData.items.push({
          id: spGiftVariantId('giftwrap', CONFIG.giftProducts.giftwrap),
          quantity: 1,
          properties: { 'Gift Wrap Theme': paperLabel, _gift_wrap_theme: paperKey }
        });
      }
      
      // Add to cart
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      const result = await response.json();
      
      if (response.ok) {
        // Update cart attributes for gift options
        await updateCartAttributes();
        
        // Redirect to cart
        setTimeout(() => {
          window.location.href = '/cart';
        }, 500);
      } else {
        throw new Error(result.message || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      alert(error.message || 'There was an error adding to cart. Please try again.');
      if (loader) loader.style.display = 'none';
    }
  }

  async function updateCartAttributes() {
    const attributes = {};

    if (state.bundleSelected) {
      attributes._custom_bundle_active = 'true';
      attributes._custom_bundle_quantity = '1';
      attributes._addon_ribbon_color = 'red';
      attributes._addon_gift_wrap_theme = window.SkylitGifts ? window.SkylitGifts.designKey(state.giftPaper) : 'regular';
      attributes._addon_gift_note = '';
    } else if (state.ribbonSelected) {
      attributes._custom_bundle_active = 'false';
      attributes._addon_ribbon_color = 'red';
      attributes._addon_gift_note = '';
    } else if (state.giftWrapSelected) {
      attributes._custom_bundle_active = 'false';
      attributes._addon_gift_wrap_theme = window.SkylitGifts ? window.SkylitGifts.designKey(state.giftPaper) : 'regular';
    } else {
      attributes._custom_bundle_active = 'false';
    }
    
    if (Object.keys(attributes).length > 0) {
      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ attributes })
        });
      } catch (e) {
        console.warn('Failed to update cart attributes:', e);
      }
    }
  }

  // ============================================
  // START
  // ============================================
  
  init();

})();